import { render, staticRenderFns } from "./affiliate-selector.vue?vue&type=template&id=51072a15&scoped=true&"
import script from "./affiliate-selector.vue?vue&type=script&lang=js&"
export * from "./affiliate-selector.vue?vue&type=script&lang=js&"
import style0 from "./affiliate-selector.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./affiliate-selector.vue?vue&type=style&index=1&id=51072a15&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "51072a15",
  null
  
)

export default component.exports